import { render, staticRenderFns } from "./ObjectsRemoveHandler.vue?vue&type=template&id=22226e12&scoped=true&"
import script from "./ObjectsRemoveHandler.vue?vue&type=script&lang=js&"
export * from "./ObjectsRemoveHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22226e12",
  null
  
)

export default component.exports